import classNames from "classnames";
import React from "react";
import PropTypes from "prop-types";

import stockAiNoPermissionYellowIcon from "./stock-ai-no-permission-yellow.svg";

import "./StockAiAnalysisLoadingIcon.scss";

const StockAiAnalysisLoadingIcon = ({
  width = 128,
  height = 128,
  className
}) => (
  <div
    className={classNames("stock-ai-analysis-loading-icon", className)}
    style={{ width, height }}
    aria-hidden="true"
  >
    <img
      src={stockAiNoPermissionYellowIcon}
      alt=""
      className="stock-ai-analysis-loading-icon__image"
    />
  </div>
);

StockAiAnalysisLoadingIcon.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  className: PropTypes.string
};

export default StockAiAnalysisLoadingIcon;
